// removed by extract-text-webpack-plugin
module.exports = {"ProductItem":"wmf-2t0CoFY4","content":"wmf-2Av_44w9","footer":"wmf-1zTm5obx","txt":"wmf-17tPvIdY"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/udeskSide/components/ProductItem.module.less
// module id = 954
// module chunks = 0